import * as yup from 'yup'

import { getMessage } from '../../util/IntlMessages'

export const ACAO_VALIDATION_SCHEMA = yup.object().shape({
  name: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('isRequired', getMessage('categoryNameField'))),
  idCategoria: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('isRequired', getMessage('categoryProposalField'))),
  classificacao: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('isRequired', getMessage('classification')))
})
